import { useCallback } from "react";
import { useState, useEffect, useRef } from "react";
import ModalError from '../Modal/ModalError';
import ModalLoading from '../Modal/ModalLoading';

export default function MapGPSLocator({ map, active, maxBounds }) {
    const [error, setError] = useState(null);
    const markerRef = useRef(null);
    const myLocationRef = useRef(null);

    // location update
    const onLocationFound = useCallback((e)=> {
        console.debug('location update:', e);
        if(markerRef.current){
            const radius = e.accuracy / 2;  
            markerRef.current.setRadius(radius);   
            markerRef.current.setLatLng(e.latlng);
            if(!myLocationRef.current && map && maxBounds){
                try {
                    const bounds = markerRef.current.getBounds();
                    const inside = new L.latLngBounds(maxBounds).contains(bounds);
                    if(inside){
                        // console.debug('flying to bounds', bounds._northEast.lat, bounds._northEast.lng, bounds._southWest.lat, bounds._southWest.lng);
                        map.flyToBounds(bounds);
                    }else{
                        setError(new Error("You're too far outside the map"));
                    }
                } catch (error) {
                    console.warn(error);
                }
            }
            myLocationRef.current = e.latlng;
        }
    }, [map, maxBounds]);

    // location error
    const onLocationError = useCallback((e)=> {
        console.error('location error:', e);
        setError(e);
    }, []);

    // init
    useEffect(()=>{
        if(map && active){
            markerRef.current = L.circle([0,0], {
                radius: 0,
                color: '#026dba',
            }).addTo(map);

            map.on('locationfound', onLocationFound);
            map.on('locationerror', onLocationError);
            map.locate({ 
                watch: true, 
                enableHighAccuracy: true,
                // maximumAge: 60000,
                // setView: true, 
                // maxZoom: 8,
            });
            return ()=>{
                if(map){
                    map.stopLocate();
                    map.off('locationfound', onLocationFound);
                    map.off('locationerror', onLocationError);
                    if(markerRef.current){
                        map.removeLayer(markerRef.current);
                    }
                    myLocationRef.current = null;
                    markerRef.current = null;
                }
            }
        }
    },[map, active, onLocationError, onLocationFound]);

    return (
        <div className='w-0 h-0 absolute top-0 left-0'>
            {error && <ModalError message={`Failed to locate you via GPS.`} description={error.message} callback={()=>setError(null)} />}
        </div>
    )
}